import React from 'react';
import Grid from '@mui/material/Grid2';

import { 
  StartEquipmentChoice,
  EquipmentPack,
} from "@dndModels";

import { ChoiceSelection } from "@dndComponents/character/inventory/startingEquipment/CSE.types";
import EquipmentOption from "@dndComponents/character/inventory/startingEquipment/CSEOption";

// Individual Equipment Choice Component
interface Props {
  choice: StartEquipmentChoice;
  selection: ChoiceSelection;
  onOptionSelect: (optionId: string) => void;
  onTypeItemSelect: (itemId: string, selectedItemId: string) => void;
  equipmentPacks: EquipmentPack[];
}

export default function EquipmentChoice({
  choice,
  selection,
  onOptionSelect,
  onTypeItemSelect,
  equipmentPacks
}: Props) {
  const hasIncompleteTypeItems = () => {
    if (!selection.selectedOptionId) return false;
    
    const option = choice.options.find(o => o.id === selection.selectedOptionId);
    if (!option) return false;
    
    return option.items.some(
      item => item.item_type === "Type" && !selection.typeItemSelections[item.id]
    );
  };

  const isIncomplete = !selection.selectedOptionId || hasIncompleteTypeItems();

  return (
    <Grid>
      <div 
        style={{
          border: isIncomplete ? "1px solid #1C9AEF" : "1px solid #777777",
          padding: "4px"
        }} 
      >
        <Grid container spacing={0} direction="column">
          {choice.options.map((option, key) => (
            <EquipmentOption
              key={key}
              option={option}
              isSelected={selection.selectedOptionId === option.id}
              typeItemSelections={selection.typeItemSelections}
              onSelect={() => {
                if (selection.selectedOptionId === option.id) {
                  onOptionSelect("");
                } else {
                  onOptionSelect(option.id);
                }
              }}
              onTypeItemSelect={onTypeItemSelect}
              equipmentPacks={equipmentPacks}
            />
          ))}
        </Grid>
      </div>
    </Grid>
  );
}